const CommonUIApiUrl = {
    //#region Common
    GetListValue: "api/CommonUI/GetListValue",
    //#endregion

    //#region City
    GetCities: "api/City/GetCities",
    GetCityInfo: "api/City/GetCityInfo",
    GetCityRelatedPackages: "api/City/GetCityRelatedPackages",
    GetDestinationExplore: "api/City/GetDestinationExplore",
    //#endregion

    //#region Common
    UploadImage: "api/Images/UploadImages",
    DeleteImageById: "api/Images/DeleteImagesByReferenceId",
    UpdateImageById: "api/Images/UpdateImagesByReferenceId",
    //#endregion

    //#region Speciality Tours
    GetSpecialityTours: "api/CommonUI/GetSpecialityTours",
    //#endregion

    //#region Speciality
    GetSpeciality: "api/CommonUI/GetSpeciality",
    GetSpecialitiesWithDepartures: "api/CommonUI/GetSpecialitiesWithDepartures",
    //#endregion

    //#region GetCountryStateById
    GetCountryStateById: "api/CommonUI/GetCountryStateById",
    //#endregion
    
    //#region GetCountryStateById
    GetCountryStateCitySpecialityByGroupId: "api/CommonUI/GetCountryStateCitySpecialityByGroupId",
    //#endregion

    //#region GetGlobalSearch
    GetGlobalSearch: "api/CommonUI/GetGlobalSearch",
    //#endregion

    //#region GetHeaderIndiaWorld
    GetHeaderIndiaWorld: "api/CommonUI/GetHeaderIndiaWorld",
    //#endregion
}
export default CommonUIApiUrl;